import Team from "../../Components/Team/teamSection"
import Footer from "../../layout/Footer"
import Header from "../../layout/Header"

export default function Teampage (){
    return(
        <>
        <Header/>
        <Team/>
        <Footer/>
        </>
    )
}

